'use strict';

var getLocale = require('../../utils/get_locale');
var getQuery = require('../../utils/get_query');
var isiOS = require('../../utils/is_ios');
var logClick = require('../../utils/log_click');
var debug = require('../../utils/debug');
var getFactParam = require('../../utils/get_fact_param');

var _require = require('../../utils'),
    getCookie = _require.getCookie;

module.exports.getDownloadUrl = function (opt) {
  checkConfig(opt);
  return getDownloadLink(opt);
};

module.exports.call = function (opt) {
  var openInNewWindow = opt.openInNewWindow,
      stats = opt.stats,
      beforeClick = opt.beforeClick;

  var link = module.exports.getDownloadUrl(opt);
  log(stats);
  if (typeof beforeClick === 'function') {
    beforeClick(link, opt);
  }
  if (openInNewWindow) {
    return window.open(link);
  }
  setTimeout(function () {
    // 延迟下载行为（跳转），以免logDownload未打出来就被浏览器主动断开连接了
    window.location.href = link;
  }, 300);
};

function log(stats) {
  logClick(stats);
  var log = require('@ali/log');
  // 标准日志
  log.download(getFactParam(stats));
}

function getDownloadLink(opt) {
  var links = opt.links;

  var downloadLink = void 0;

  if (!Array.isArray(links)) {
    throw new Error('下载配置不正确');
  }

  links.forEach(function (_ref) {
    var condition = _ref.condition,
        link = _ref.link;

    if (!downloadLink && isMatchCondition(condition)) {
      downloadLink = link;
    }
  });

  // 如果都没匹配上，使用最后一个值
  if (!downloadLink) {
    downloadLink = links[links.length - 1].link;
  }

  debug('[download] 下载链接localeKey:', downloadLink);
  downloadLink = getLocale(downloadLink);
  debug('[download] 下载链接Url:', downloadLink);

  if (opt.nineApps && isNineApps(opt)) {
    downloadLink = getNineAppsLink(opt.nineApps, downloadLink);
  }
  return downloadLink;
}

function checkConfig(opt) {
  if (!opt.hasOwnProperty('links')) {
    throw new Error('请配置下载链接');
  }
}

function isMatchCondition(_ref2) {
  var bi = _ref2.bi,
      query = _ref2.query,
      versionRange = _ref2.versionRange,
      platform = _ref2.platform;

  return isMatchVersionRange(versionRange) && isMatchBi(bi) && isMatchPlatform(platform) && isMatchQuery(query);
}

function isMatchPlatform(platform) {
  var ua_platform = isiOS() ? 'IOS' : getCookie('ua_platform');
  return !platform || ua_platform && !!ua_platform.match(platform);
}

function isMatchBi(bi) {
  return !bi || bi === getCookie('ua_bi');
}

function isMatchQuery(query) {
  if (!query) {
    return true;
  }
  var result = true;
  for (var p in query) {
    if (!getQuery(p) || !getQuery(p).match(query[p])) {
      result = false;
    }
  }
  return result;
}

// 对比版本号
function isMatchVersionRange(versionRange) {

  if (!versionRange) {
    return true;
  }
  var browserVersion = getCookie('ua_version');

  if (Array.isArray(versionRange)) {
    var startVer = versionRange[0];
    var endVer = versionRange[1];

    if (startVer === '~') {
      return hasEqualCompare({ big: endVer, small: browserVersion });
    }

    if (endVer === '~') {
      return hasEqualCompare({ small: startVer, big: browserVersion });
    }

    if (startVer !== '~' && endVer !== '~') {
      return hasEqualCompare({ small: startVer, big: browserVersion }) && hasEqualCompare({ big: endVer, small: browserVersion });
    }
  }
}

// 判断是否有等号的比较
function hasEqualCompare(_ref3) {
  var small = _ref3.small,
      big = _ref3.big;

  var smallVersion = small && small[0] === '=' ? small.substring(1) : small;
  var bigVersion = big && big[0] === '=' ? big.substring(1) : big;
  if (small && small[0] === '=' || big && big[0] === '=') {
    return formatVersion(smallVersion) <= formatVersion(bigVersion);
  }
  return formatVersion(smallVersion) < formatVersion(bigVersion);
}

function addZero(str, length) {
  var padLeft = length - str.length + 1;
  padLeft = padLeft < 0 ? 0 : padLeft;
  return new Array(padLeft).join('0') + str;
}

function formatVersion() {
  var version = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  return version.split('.').map(function (i) {
    return addZero(i, 5);
  }).join('.');
}

function isNineApps(opt) {
  var nineAppsEntry = getLocale(opt.nineApps.entry);
  var entry = getQuery('entry');
  return entry && entry === nineAppsEntry;
}

function getNineAppsLink(nineAppsOpt, downloadLink) {
  var publicId = getLocale(nineAppsOpt.publicId);
  var packageId = getLocale(nineAppsOpt.packageId);

  // 9游新版
  if (window.Android) {
    return 'nineapps://silentDownload?publicId=' + publicId;
  }

  var connector = downloadLink.indexOf('?') > -1 ? '&' : '?';
  // 9游旧版 TODO 参数最好不要这样直接拼
  return '' + downloadLink + connector + 'renderType=appDownload&packageId=' + packageId;
}